export default __webpack_public_path__ + "static/media/LINK.be50a17d.svg";